import { render, staticRenderFns } from "./empiecement-doudoune.vue?vue&type=template&id=7c6d0c96"
import script from "./empiecement-doudoune.vue?vue&type=script&lang=js"
export * from "./empiecement-doudoune.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports